/** Extract checkout session id from API link text or URL (e.g. .../pay/abc123). */
export function extractPaySessionId(link: string): string | null {
  const trimmed = link.trim();
  if (!trimmed) return null;

  const pathMatch = trimmed.match(/\/pay\/([^/?#\s]+)/i);
  if (pathMatch?.[1]) return pathMatch[1];

  const absoluteMatch = trimmed.match(/https?:\/\/[^/]+\/pay\/([^/?#\s]+)/i);
  return absoluteMatch?.[1] ?? null;
}

/** Checkout route on the current app origin (avoids backend UrlUi pointing at localhost). */
export function checkoutPathForSession(sessionId: string): string {
  return `/pay/${encodeURIComponent(sessionId)}`;
}

export function checkoutUrlForSession(sessionId: string): string {
  return `${window.location.origin}${checkoutPathForSession(sessionId)}`;
}
